module.exports = __webpack_public_path__ + "img/badge_gray_fia-application.8a4925f6.svg";